import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    highlighted: {
        backgroundColor: 'lightyellow',
    },
};
